<div>
    <div class="row mt-3">
        <div class="col-8">
            <div class="mb-3 d-flex justify-content-between">
                <h2 class="title-list">List of Distributor Customers</h2>
            </div>
        </div>

        <div class="col-2 text-end">
            <button class="btn btn-primary"  (click)="transferCustomers()" [disabled]="selectedCustomers.length === 0" *ngIf="permissionsService.editPermission">
                Transfer Customers
            </button>
        </div>

        <div class="col-2 text-end">
            <button class="btn btn-primary" (click)="assignCustomers()" *ngIf="permissionsService.editPermission">
                Assign Customers
            </button>
        </div>


    </div>
    <div>
        <app-table-control [data]="distributorCustomerList" [columns]="columns" [pageSize]="5"
                           [showCheckboxes]="permissionsService.isAdmin"
                           [selectedItems]="selectedCustomers">
        </app-table-control>
    </div>
</div>


<!-- Modal Assign Customers -->
<div id="modalAssignCustomers" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title modal-titles" style="font-weight: bold;">Assign Customers</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="mb-4">
                    Please select the customers you want to assign to this distributor.
                </div>
                <app-table-control [data]="customersToAssignList" [columns]="assignCustomersColumns" [pageSize]="7"
                                   [showCheckboxes]="true"
                                   [selectedItems]="selectedCustomersToAssign"
                                   >
                </app-table-control>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="dialog.close(true)">
                    Assign Customers
                </button>
            </div>
        </div>
    </div>
</div>


<!-- Modal Transfer Customers -->
<div id="modalTransferCustomers" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title modal-titles" style="font-weight: bold;">Transfer Customers</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="mb-4">Please select the new Distributor:</div>

                <app-table-control [data]="distributorsToTransferList" [columns]="transferDistributorsColumns" [pageSize]="7"
                                   [showCheckboxes]="true"
                                   [isMultiSelect]="false"
                                   [selectedItems]="selectedDistributorsToTransfer">
                </app-table-control>

            </div>
            <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="dialog.close(true)" [disabled]="selectedDistributorsToTransfer.length === 0">
                        Transfer Customers
                    </button>
            </div>
        </div>
    </div>
</div>
